import React, { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext();

const getInitialTheme = () => {
  try {
    const saved = localStorage.getItem("theme");
    if (saved === "dark") {
      return { value: "dark", label: "Dark" };
    }
    if (saved === "light") {
      return { value: "light", label: "Light" };
    }
  } catch (e) {}
  return { value: "light", label: "Light" };
};

const ThemeContextProvider = (props) => {
  const body = typeof document !== "undefined" ? document.querySelector("body") : null;
  const [background, setBackground] = useState(getInitialTheme);
  const [sidebarLayout, setSidebarLayout] = useState({ value: "vertical", label: "Vertical" });
  const [sideBarStyle, setSideBarStyle] = useState({ value: "full", label: "Full" });
  const [sidebarposition, setSidebarposition] = useState({ value: "fixed", label: "Fixed" });

  const [sidebariconHover, setSidebariconHover] = useState(false);
  const [menuToggle, setMenuToggle] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  const changeSideBarPostion = (name) => {
    setSidebarposition(name);
    const bodyEl = document.querySelector("body");
    if (bodyEl) bodyEl.setAttribute("data-sidebar-position", name.value);
  };

  const ChangeIconSidebar = (value) => {
    if (sideBarStyle.value === "icon-hover") {
      setSidebariconHover(Boolean(value));
    }
  };

  const openMenuToggle = () => {
    setMenuToggle(sideBarStyle.value === "overly");
  };

  const changeBackground = (name) => {
    try {
      localStorage.setItem("theme", name.value);
    } catch (e) {}
    const bodyEl = document.querySelector("body");
    if (bodyEl) {
      bodyEl.setAttribute("data-theme-version", name.value);
    }
    if (typeof document !== "undefined" && document.documentElement) {
      document.documentElement.setAttribute("data-theme-version", name.value);
      if (name.value === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    }
    setBackground(name);
  };

  useEffect(() => {
    const bodyEl = document.querySelector("body");
    if (bodyEl) {
      bodyEl.setAttribute("data-theme-version", background.value);
    }
    if (typeof document !== "undefined" && document.documentElement) {
      document.documentElement.setAttribute("data-theme-version", background.value);
      if (background.value === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    }
  }, [background.value]);

  useEffect(() => {
    const bodyEl = document.querySelector("body");
    const resizeWindow = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
      if (bodyEl) {
        if (window.innerWidth >= 768 && window.innerWidth < 1024) {
          bodyEl.setAttribute("data-sidebar-style", "mini");
        } else if (window.innerWidth <= 768) {
          bodyEl.setAttribute("data-sidebar-style", "overlay");
        } else {
          bodyEl.setAttribute("data-sidebar-style", "full");
        }
      }
    };
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        body,
        sidebarposition,
        windowWidth,
        windowHeight,
        sideBarStyle,
        changeSideBarPostion,
        sidebarLayout,
        ChangeIconSidebar,
        sidebariconHover,
        menuToggle,
        openMenuToggle,
        changeBackground,
        background,
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;